module.exports = __webpack_public_path__ + "static/media/slide-pad.407e0ee8.svg";